import styled, { Button } from "grabcad-ui-elements";

export const Banner = styled.div<{ background: string }>`
    width: calc(100% - 2 * 10px);
    margin: 9px auto;
    max-width: 1060px;

    .banner {
        border-radius: 10px;
        background-image: url(${(props) => props.background});
        padding: 12px 8px;
        height: 90px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .text-section {
        display: flex;
        flex-direction: column; /* stack h1 one over the other */
        gap: 2px; /* small space between headings */
        margin: 5px 0 0 20px;
    }

    h1,
    h4 {
        font-family: "DM Sans";
        font-style: normal;
        margin: 0;
        color: white !important;
    }
`;

export const ConfigureButton = styled(Button)`
    background: white !important;
    color: #700ac1 !important;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    font-weight: bold;
    cursor: pointer;
    margin-right: 20px !important;
`;
